import ReceiptPrinterEncoder from '@point-of-sale/receipt-printer-encoder';

export function formatTicketData(lines: string[], cpl: number){
  return lines.map((line) => {
    if(line.includes("------") && line.length < cpl){
      return line.padEnd(cpl, '-');
    }

    if(line.includes(": ")){
      const content = line.trim().split(': ');
      if (content.length == 2) {
        let leftSide = content[0].trim();
        let rightSide = content[1].trim();
        let middleSpace = ' '.padEnd((cpl - leftSide.length - rightSide.length), ' ');
        // Concatenate the left side, middle space, and right side
        return leftSide + middleSpace + rightSide;
      }
    }

    return line;
  })
}



export async function EscPosCommand(data:string[], cpl: number){

  let encoder = new ReceiptPrinterEncoder({language: 'esc-pos', feedBeforeCut: 4, columns: cpl });

  encoder = encoder
            .initialize()
            .codepage('auto');

  if (data.some((line) => line.includes("#_01_#"))) {
      let imageData = await scaleImageToMultipleOf8('/images/png/logo/print-logo.png');
      encoder = encoder
        .align('center')
        .image(imageData, 320, 120, 'atkinson');
        console.log('1');
  }

  formatTicketData(data, cpl).forEach(async (line, index, lines) => {

    if (line.includes("#_01_#")) {
      return;
    } else if (line.includes("#_02_#")) {
      let refCode = lines[3].trim();

      encoder = encoder
        .align('center')
        .barcode(refCode, 'code128', { text: true, width: 1 });
      lines.splice(3, 1);

    } else if (line.includes("#_03_#")) {
      let refCode = lines[6].trim();

      encoder = encoder
        .align('center')
        .qrcode(refCode, { size: 8 });

      lines.splice(6, 1);

    } else if (line.includes('----')) {
      encoder = encoder
        .align('left')
        .rule();
    } else {
      let separatorBefore = index - 1 >= 0 && (lines[index - 1].includes("--------") || lines[index - 1].includes("#_01_#"));
      let separatorAfter = index + 1 < lines.length && lines[index + 1].includes("--------");
      let align = separatorAfter && separatorBefore ? 'center' : 'left';

      encoder = encoder
        .align(align)
        .bold(separatorAfter && separatorBefore)
        .line(line)
        .bold(false);
    }
  });
  console.log('2');
  encoder = encoder.cut();

  return encoder.encode();
}
function scaleImageToMultipleOf8(url: string, scale: number = 1): Promise<HTMLCanvasElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Enable for local/test images
    img.src = url;

    img.onload = () => {
      // Step 1: Scale original dimensions
      let scaledWidth = Math.round(img.width * scale);
      let scaledHeight = Math.round(img.height * scale);

      // Step 2: Round up to nearest multiple of 8
      scaledWidth = Math.ceil(scaledWidth / 8) * 8;
      scaledHeight = Math.ceil(scaledHeight / 8) * 8;

      // Step 3: Draw to canvas
      const canvas = document.createElement('canvas');
      canvas.width = scaledWidth;
      canvas.height = scaledHeight;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.imageSmoothingEnabled = false; // Optional: pixel-art style
        ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight);
        resolve(canvas);
      } else {
        reject("Could not get 2D context");
      }
    };

    img.onerror = reject;
  });
}


export function bufferToHex(buffer: Uint8Array): string {
  return Array.from(buffer)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}
